import React from "react";
import {useState} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {default as MuiModal} from "@mui/material/Modal";
import emailAddressImg from "../../assets/img/email-address.jpg";
import {useTranslation} from "react-i18next";

interface Props {
  openModal: boolean;
  onChangeModal: React.Dispatch<React.SetStateAction<boolean>>;
}
export const ContactModal: React.FC<Props> = ({openModal, onChangeModal}) => {
  const [isCopiedEmail, setIsCopiedEmail] = useState<boolean>(false);
  const {t} = useTranslation();

  const handleCopyEmail = () => {
    navigator.clipboard.writeText("sebastian.j.pitra@gmail.com");
    setIsCopiedEmail(true);
  };

  const handleCloseModal = () => {
    setIsCopiedEmail(false);
    onChangeModal(false);
  };

  return (
    <MuiModal
      open={openModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {xs: "90%", sm: 400},
          bgcolor: "#1715A0",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {t("contactModal.title")}
        </Typography>

        <Typography id="modal-modal-description" sx={{mt: 2}}>
          {t("contactModal.message")}
          <br />
          <br />
          {t("contactModal.emailAddress")}:
          <img
            src={emailAddressImg}
            alt="email address to contact me"
            className="rounded-skill-card"
          />
        </Typography>

        {isCopiedEmail && (
          <Typography sx={{mt: 2}} style={{color: "#02fe15"}}>
            {t("contactModal.emailCopied")}:
          </Typography>
        )}

        <div className=" mt-4 flex justify-end gap-5">
          <button className="p-2" onClick={handleCloseModal}>
            {t("contactModal.closeModal")}
          </button>
          <button
            onClick={handleCopyEmail}
            className="p-2 rounded-skill-card"
            style={{backgroundColor: "#005EFF"}}
          >
            {t("contactModal.copyEmail")}
          </button>
        </div>
      </Box>
    </MuiModal>
  );
};
